"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
const noop = function () {
  return undefined;
};
exports.noop = noop;
//# sourceMappingURL=noop.js.map